module.exports = __webpack_public_path__ + "img/logo_recuperi_azul_escura_parceiro_boavista.43bcbd8b.png";